export const SUPPORTED_LANGUAGES = ['es', 'en'] as const;
export type Language = (typeof SUPPORTED_LANGUAGES)[number];

export const DEFAULT_LANGUAGE: Language = 'es';

export function normalizeLanguage(language?: string | null): Language {
  return SUPPORTED_LANGUAGES.includes(language as Language)
    ? (language as Language)
    : DEFAULT_LANGUAGE;
}
